module.exports = __webpack_public_path__ + "img/user-avator.8be56e97.svg";